<template>
    <div class="main">
        <div class="desc big-font bold-font" :class="`gradient-bg-${variant}`">
            <img
                class="logo"
                :src="require(`@/assets/logo.png`)"
                :alt="company.name"
            />
        </div>
        <div class="addr">
            <img
                class="logoaws"
                :src="require(`@/assets/logo-aws.png`)"
                :alt="company.name"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'app-header',
    props: ['logo', 'variant'],
    data() {
        return {};
    },
    computed: {
        ...mapState({
            company: (state) => state.Invoice.company,
        }),
    },
};
</script>

<style lang="scss" scoped>
@import 'main';
.main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 3rem 0;
}

.logo {
    width: 100%;
    max-width: 200px;
    height: auto;
}

.logoaws {
    width: 100%;
    max-width: 200px;
    height: auto;
}

.desc {
    font-size: 1.3rem;
    letter-spacing: 0.3rem;
    letter-spacing: 4px;
    text-transform: uppercase;
}
.addr {
    color: $color-grey-primary;
    text-align: right;
}
</style>
